/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import useCustomMutationReactQuery from '../generalHooks/useCustomMutationReactQuery'
import { getUserList, updatePostById } from '../../apiProcess/sampleApi'
import _ from 'lodash'
import { loginProcess, otpProcess } from '@/utility/apiProcess/auth/login'
import { toast } from 'react-toastify'
import { getUpcomingEvents } from '@/utility/apiProcess/events'
import { getListCareer } from '@/utility/apiProcess/career'
import { getDetailFaqList, getFaqByTopic, getFaqTopics } from '@/utility/apiProcess/help-center'
import { getDetailPress, getPressList } from '@/utility/apiProcess/press'
import dayjs from 'dayjs'

const usePressQuery = () => {
  // get press list
	const [pressList, setPressList] = useState<any>([])
	const [pressPageInfo, setPressPageInfo] = useState<any>([])
	const [isSearch, setIsSearch] = useState<any>(false)
  const {
		isLoading: loadingPressList,
		return_data: rawPressList,
		startFetch: startPressList,
	} = useCustomMutationReactQuery(getPressList, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(rawPressList)) {
			const data:any = []
			rawPressList.data.data.map((item: any, index:number) => {
				data.push({
					id: item.id,
					title: item.title,
					img: item.image_url,
					date: dayjs(item.publish_date).format('DD MMMM YYYY'),
					descriptiom: item.description,
					type: item.type_name,
					author: item.author,
				})
			})
			
			if(isSearch === false) {
				setPressList(data)
			} else {
				setPressList((prev:any) => [...prev, ...data])
			}
			setPressPageInfo(rawPressList.data.infoPage)
		}
	},[rawPressList])
  
	// get detail press
	const [pressDetail, setPressDetail] = useState<any>({})
	const [pressRelatedArticle, setPressRelatedArticle] = useState<any>([])
	const {
		isLoading: loadingPressDetail,
		return_data: PressDetailRaw,
		startFetch: startPressDetail,
	} = useCustomMutationReactQuery(getDetailPress, {
		onError: (error: Error) => console.log(error),
		isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(PressDetailRaw)) {
			setPressDetail(PressDetailRaw.data.data.data)
			setPressRelatedArticle(PressDetailRaw.data.data.other)
		}
	},[PressDetailRaw])

	return {
    pressList,
		startPressList,
		pressPageInfo,
		startPressDetail,
		pressDetail,
		pressRelatedArticle,
		setIsSearch,
		loadingPressList,
		loadingPressDetail
	}
}

export default usePressQuery
